/**
 * Created by USER on 2018/11/1.
 */
import {
  GET_PARTNER,
  GET_BANNER
} from '../actions/home_page_action';
import ImgList from '../../images/img';

const initState = {
  partnerData: [],
  Banner: ['', '', '', '']
};

export default function homePageReducer(state = initState, action) {
  switch (action.type) {
    case GET_BANNER:
      return Object.assign({}, state, { Banner: action.data});
    case GET_PARTNER:
      return Object.assign({}, state, { partnerData: action.data});
    default:
      return state;
  }
}